// @ts-nocheck
import React from 'react';
import {
  Tile,
  Form,
  FormGroup,
  TextInput,
  Select,
  SelectItem,
  Toggle,
  Button,
  Grid,
  Column,
  InlineNotification,
  Stack,
} from '@carbon/react';
import { Settings } from '@carbon/icons-react';
import SecuritySettings from '../../components/security/SecuritySettings';

function FamilySettings() {
  return (
    <div
      style={{
        padding: 'var(--cds-spacing-07)',
        marginLeft: '240px', // Keep sidebar spacing if needed
      }}
    >
      <h2
        className="cds--type-display-01"
        style={{
          marginBottom: 'var(--cds-spacing-06)',
          color: 'var(--cds-interactive-01)',
        }}
      >
        Family Settings
      </h2>

      <Grid>
        {/* Security Settings - Epic #87 */}
        <Column sm={4} md={8} lg={16}>
          <SecuritySettings />
        </Column>

        {/* Communication Preferences */}
        <Column sm={4} md={8} lg={8}>
          <Tile style={{ marginBottom: 'var(--cds-spacing-05)' }}>
            <h3
              className="cds--type-heading-compact-02"
              style={{
                marginBottom: 'var(--cds-spacing-05)',
              }}
            >
              Communication Preferences
            </h3>
            <Form layout="vertical">
              <FormGroup label="Email Notifications">
                <Stack direction="vertical" style={{ width: '100%' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span>Achievement notifications</span>
                    <Toggle defaultChecked />
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span>Progress reports</span>
                    <Toggle defaultChecked />
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span>Concern alerts</span>
                    <Toggle defaultChecked />
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span>Daily summaries</span>
                    <Toggle />
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span>Weekly reports</span>
                    <Toggle defaultChecked />
                  </div>
                </Stack>
              </FormGroup>

              <FormGroup>
                <Select id="notification-frequency" defaultValue="daily" labelText="Notification Frequency">
                  <SelectItem value="immediate" text="Immediate" />
                  <SelectItem value="daily" text="Daily Digest" />
                  <SelectItem value="weekly" text="Weekly Summary" />
                </Select>
              </FormGroup>

              <FormGroup>
                <Select id="preferred-language" defaultValue="en" labelText="Preferred Language">
                  <SelectItem value="en" text="English" />
                  <SelectItem value="pt" text="Portuguese" />
                  <SelectItem value="es" text="Spanish" />
                </Select>
              </FormGroup>
            </Form>
          </Tile>
        </Column>

        {/* Privacy Settings */}
        <Column sm={4} md={8} lg={8}>
          <Tile title="Privacy Settings" style={{ marginBottom: '16px' }}>
            <Form layout="vertical">
              <FormGroup>
                <Select id="data-sharing" defaultValue="summary" labelText="Data Sharing Level">
                  <SelectItem value="minimal" text="Minimal - Basic progress only" />
                  <SelectItem value="summary" text="Summary - Progress with insights" />
                  <SelectItem value="detailed" text="Detailed - Full learning analytics" />
                </Select>
              </FormGroup>

              <FormGroup label="Privacy Controls">
                <Stack direction="vertical" style={{ width: '100%' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span>Third-party sharing</span>
                    <Toggle />
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span>Research participation</span>
                    <Toggle />
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span>Marketing communications</span>
                    <Toggle />
                  </div>
                </Stack>
              </FormGroup>

              <div style={{ marginTop: 'var(--cds-spacing-05)' }}>
                <InlineNotification
                  kind="success"
                  title="Privacy Protection"
                  subtitle="Your family's data is FERPA and COPPA compliant. All student information is encrypted and access is strictly controlled according to educational privacy laws."
                  hideCloseButton
                  lowContrast
                />
              </div>
            </Form>
          </Tile>
        </Column>

        {/* Account Information */}
        <Column span={16}>
          <Tile style={{ marginBottom: 'var(--cds-spacing-05)' }}>
            <h3
              className="cds--type-heading-compact-02"
              style={{
                marginBottom: 'var(--cds-spacing-05)',
              }}
            >
              Family Account Information
            </h3>
            <Grid>
              <Column sm={4} md={4} lg={8}>
                <Form layout="vertical">
                  <FormGroup>
                    <TextInput id="family-name" defaultValue="The Johnson Family" labelText="Family Name" />
                  </FormGroup>
                  <FormGroup>
                    <TextInput id="parent-email" defaultValue="parent@example.com" labelText="Primary Parent Email" />
                  </FormGroup>
                </Form>
              </Column>
              <Column sm={4} md={4} lg={8}>
                <Form layout="vertical">
                  <FormGroup>
                    <Select id="subscription-plan" defaultValue="free" labelText="Subscription Plan">
                      <SelectItem value="free" text="Free Plan" />
                      <SelectItem value="basic" text="Basic Plan - $9.99/month" />
                      <SelectItem value="premium" text="Premium Plan - $19.99/month" />
                      <SelectItem value="family" text="Family Plan - $29.99/month" />
                    </Select>
                  </FormGroup>
                  <FormGroup>
                    <div>
                      <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>Account Status</label>
                      <span style={{ color: '#52c41a', fontWeight: 500 }}>Active • Trial (28 days remaining)</span>
                    </div>
                  </FormGroup>
                </Form>
              </Column>
            </Grid>

            <hr style={{ margin: '16px 0', border: '1px solid #e0e0e0' }} />

            <Stack>
              <Button kind="primary">Save Settings</Button>
              <Button>Cancel Changes</Button>
              <Button danger kind="ghost" style={{ marginLeft: 'auto' }}>
                Export Family Data
              </Button>
            </Stack>
          </Tile>
        </Column>
      </Grid>
    </div>
  );
}

export default FamilySettings;
